import { CONFIG } from "../api/config";

const GA_ID = CONFIG.GA_ID;

export const initGA = () => {
  if (!GA_ID) return;

  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    
    gtag('js', new Date());

    gtag('consent', 'default', {
      'analytics_storage': 'denied'
    });
  `;
  document.head.appendChild(script2);
};

export const enableGA = () => {
    if (!GA_ID) return;
  
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
  
      window.gtag('config', GA_ID);
    }
  };
  
export const logGAEvent = (
    action: string,
    category: string,
    label: string
  ) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
      });
    }
  };
  